import { notify } from '@/utils/notify';
import AlertIcon from '@/components/Notifications/AlertIcon';
import SuccessIcon from '@/components/Notifications/SuccessIcon';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';

interface Props {
    value: string | number;
    title: string;
}

const CopyBlock = ({ value, title }: Props) => {
    const copy = () => {
        try {
            navigator.clipboard.writeText(value.toString()).then(() =>
                notify(
                    'success',
                    <SuccessIcon />,
                    <NotifyWrapper title="Success" text="Text was copied" />
                )
            );
        } catch (e) {
            notify('error', <AlertIcon />, <NotifyWrapper title="Error" text={String(e)} />);
        }
    };

    return (
        <div className="flex flex-col gap-1.5">
            <span className="text-[11px] uppercase tracking-[0.10em] text-text_4 font-bold">
                {title}
            </span>
            <button
                type="button"
                onClick={copy}
                className="w-full inline-flex items-center justify-between gap-3 px-3.5 py-2.5 rounded-fl bg-layer_2 border border-stroke text-text_main hover:bg-layer_3 hover:border-stroke_strong transition-colors text-left"
            >
                <span className="font-mono text-[13px] text-text_2 truncate">{value}</span>
                <svg
                    viewBox="0 0 24 24"
                    className="w-4 h-4 stroke-current fill-none text-text_3 [stroke-width:1.8] [stroke-linecap:round] [stroke-linejoin:round] shrink-0"
                >
                    <rect x="9" y="9" width="11" height="11" rx="2" />
                    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
                </svg>
            </button>
        </div>
    );
};

export default CopyBlock;
